import {Box, Center, Flex, Icon, Image, Text} from '@chakra-ui/react'
import {Progress} from 'antd'
import {ReactComponent as ArrowRight4} from '@assets/svgs/learn/arrow_right_4.svg'
import {CommonColors} from '@utils/CommonStyles'

const CardTopic = ({
  title,
  subtitle,
  image,
  completedLesson,
  totalLesson,
  progress,
  type = '',
  band = '',
  onClick,
}: {
  title: string
  subtitle: string
  image: string
  completedLesson: number
  totalLesson: number
  progress: number
  type?: string
  band?: any
  onClick: () => void
}) => {
  return (
    <Flex
      flexDirection={'column'}
      h={'100%'}
      borderRadius="12px"
      border="2px solid #f3f3f3"
      p={{base: '16px', md: '20px'}}
      cursor={'pointer'}
      _hover={{
        border: '2px solid #8ED4FF',
        boxShadow: '0px 4px 0px 0px #8ED4FF',
        '& svg': {
          stroke: CommonColors.primary,
        },
      }}
      onClick={onClick}>
      <Flex justifyContent={'space-between'} mb={'16px'}>
        <Center
          w={{base: '100px', lg: '150px'}}
          h={{base: '100px', lg: '150px'}}
          bg={'linear-gradient(180deg, #EEF8FF 0%, #f5f5f5 100%)'}
          borderRadius={'16px'}
          p={'16px'}>
          <Image w={'100%'} h={'100%'} objectFit={'cover'} src={image} />
        </Center>
        <Flex flexDirection={'column'}>
          <Progress
            percent={Math.round(progress)}
            format={percent =>
              type === 'exam' ? (
                <Text fontSize={{base: '14px', md: '16px'}} fontWeight={'600'}>
                  {band ? band : '--'}
                </Text>
              ) : (
                `${percent}%`
              )
            }
            type="dashboard"
            size={64}
            strokeWidth={10}
            strokeColor={'#339CFF'}
          />
          {Boolean(completedLesson && totalLesson) && (
            <Text
              fontSize={'12px'}
              fontWeight={'500'}
              color={'#989898'}
              alignSelf={'center'}>
              {`${completedLesson}/${totalLesson} câu`}
            </Text>
          )}
        </Flex>
      </Flex>
      <Flex
        mt={'auto'}
        justifyContent={'space-between'}
        alignItems={'center'}
        gap={'16px'}>
        <Box>
          <Text fontSize={'16px'} fontWeight={'600'}>
            {title}
          </Text>
          <Text fontSize={'12px'} fontWeight={'500'} color={'#989898'}>
            {subtitle}
          </Text>
        </Box>
        <Icon
          w={'24px'}
          h={'24px'}
          sx={{
            stroke: '#BDBDBD',
            transition: 'stroke 0.2s ease-in-out',
          }}>
          <ArrowRight4 />
        </Icon>
      </Flex>
    </Flex>
  )
}

export default CardTopic
